import React from 'react';
import {Text} from '@sitecore-jss/sitecore-jss-react';
import {withSitecoreContext} from '@sitecore-jss/sitecore-jss-react';
import {PropTypes, DefaultProps} from '../../../core/Utils/SitecoreFields';
import AccordionItem from './Components/AccordionItem';

/**
 * Helper that grabs hash value from browser URL if it exists
 * @return	{string}	The hash value of the URL. Returns -1 if hash value is an empty string. 
 */
const hashString = () => {
	return window.location.hash.substr(1) || -1;
};

class Accordion extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hash: null,
			active: -1,
			headerType: props.sitecoreContext.route.placeholders['global-header'][0].componentName,
		};
		this.handleClick = this.handleClick.bind(this);
	}

	componentDidMount() {
		// find accordion item that has the # ID value. Then set as active item
		// const this.props.fields.accordionItems.findIndex( item => item.fields.accordionItemID.value === hash);
		this.setState({ 
			active: this.hashItemIndex(this.props.fields.accordionItems),
			hash: hashString(),
		});
	}

	componentDidUpdate() {
		const detectedHashIndex = this.hashItemIndex(this.props.fields.accordionItems);
		if(hashString() !== this.state.hash) {
			this.setState({
				active: detectedHashIndex,
				hash: hashString()
			});
		}
	
	}

	/**
 * Searches the accordion list for the item with the hash ID, and returns the index location of found item.
 * @param 	{object}	accordionItems 	Object list of accordion items
 * @return 	{int}											Index location of accordion item in the list. Returns -1 if not found.
 */
	hashItemIndex(accordionItems) {
		return accordionItems.findIndex( item => item.fields.accordionItemID.value === hashString()); 
	}

	handleClick(e, index) {
		const headerTopOffset = 125;
		const mobileWidthLimit = 1024;
		const eventTarget = e.target;
		this.setState(prevState => {
			if(prevState.active === index) {
				return {
					active: -1
				};
			} else {
				eventTarget.scrollIntoView();
				// Settimeout created so that scroll is queued after the react rendering
				setTimeout(
					() => {
						eventTarget.scrollIntoView();
						// If page is viewed on desktop
						// and is using the regular Header then scroll needs to offset header height
						if(this.state.headerType === 'Header' && window.innerWidth >= mobileWidthLimit){
							window.scrollBy(0, -headerTopOffset);
						}
					}, 0);
				return {
					active: index,
				};
			}
		});
	}

	render() {
		const {heading, description, accordionItems, className} = this.props.fields;
		return (
			<div className={`stacked-accordions ${className.value}`}>
				<Text className="accordion-section-heading" field={heading} tag="h3" />
				{!!description && !!description.value &&
					<Text field={description} tag="p" />
				}
				{accordionItems.map((item, index) => (
					<AccordionItem
						fields={item.fields}
						key={item.id}
						index={index}
						handleClick={(e) => this.handleClick(e, index)}
						isActive={index === this.state.active}
					/>
				))}
			</div>
		);
	}
}

Accordion.propTypes = PropTypes.SitecoreItem.inject({
	heading: PropTypes.SingleLineText,
	accordionItems: PropTypes.Multilist.inject({
		accordionItemTitle: PropTypes.SingleLineText,
		accordionItemBody: PropTypes.RichText,
	}),
});

Accordion.defaultProps = DefaultProps.SitecoreItem.inject({
	heading: DefaultProps.SingleLineText,
	accordionItems: DefaultProps.Multilist,
});

export default withSitecoreContext()(Accordion);
